export enum enumNotification {
  'TEXT' = 1,
  'HTML'
}

export namespace enumNotification {
  export function values() {
    return Object.keys(enumNotification).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
